import React from 'react';
import { Link } from 'react-router-dom';

const Gallery: React.FC = () => {
  const galleryItems = [
    { id: 1, title: 'Tailored Suits', category: 'Formal', image: '/images/collection/suits.jpg' },
    { id: 2, title: 'Football Jerseys', category: 'Sport', image: '/images/collection/jersey.webp' },
    { id: 3, title: 'Training Kits', category: 'Performance', image: '/images/collection/kits.jpeg' },
    { id: 4, title: 'Formal Wear', category: 'Blazers & Shirts', image: '/images/collection/formal.webp' },
    { id: 5, title: 'Match Jerseys', category: 'Club & Fan', image: '/images/collection/soccer.webp' },
    { id: 6, title: 'Training Gear', category: 'Gym & Run', image: '/images/collection/gear.jpg' },
  ];

  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <h2 className="font-display text-3xl md:text-4xl font-semibold text-slate-900 tracking-tight">
            Collections
          </h2>
          <p className="mt-3 text-slate-600">
            Suits, jerseys, and kits — for the boardroom, the pitch, and the gym.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6">
          {galleryItems.map((item) => (
            <Link
              key={item.id}
              to="/collections"
              className="group relative aspect-[3/4] rounded-2xl overflow-hidden bg-slate-100"
            >
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/70 via-slate-900/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="absolute inset-0 flex flex-col justify-end p-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <span className="text-xs font-medium uppercase tracking-wider text-white/80">
                  {item.category}
                </span>
                <h3 className="font-display font-semibold text-white text-lg mt-1">
                  {item.title}
                </h3>
              </div>
              <div className="absolute bottom-6 left-6 right-6 opacity-0 group-hover:opacity-100 transition-opacity">
                <span className="text-sm font-medium text-white/90">View collection →</span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/collections"
            className="inline-flex items-center justify-center px-6 py-3 rounded-lg border border-slate-300 text-slate-700 font-medium text-sm hover:bg-slate-50 transition-colors"
          >
            View all collections
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
